import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import io from "socket.io-client";

import axios from "axios";

import { roomLeave } from "../../../redux/actions/roomAction";
import { SetRole } from "../../../redux/actions/userAction";
import {
	WhiteMoved,
	BlackMoved,
	WhiteCastled,
	BlackCastled,
	WhiteCapturedBlack,
	BlackCapturedWhite,
	WhitePromotedByMove,
	BlackPromotedByMove,
	WhitePromotedByCapture,
	BlackPromotedByCapture,
	SetWhiteCastleState,
	SetBlackCastleState,
	AddHistory,
	ResetHistory,
	InitialPosition,
	SetGameOver,
} from "../../../redux/actions/chessAction";

import { RookScopeMove, KnightScopeMove, BishopScopeMove, KingScopeMove, PawnScopeMove } from "./../chess/chessScript/chessScope";
import { renderCaptureHolder, renderBoardAndPieces } from "./../chess/chessScript/chessRender";
import { isOutOfMove } from "./../chess/chessScript/chessAllMove";
import { isUnderAttack } from "./../chess/chessScript/chessUnderAttack";

import BoardWhite from "./../chess/chessBoard/boardWhite";
import BoardBlack from "./../chess/chessBoard/boardBlack";

import PromotionWhite from "./../chess/chessPromotion/promotionWhite";
import PromotionBlack from "./../chess/chessPromotion/promotionBlack";
import GameOverMenu from "./../chess/chessMenu/gameOverMenu";
import SideMenu from "./../chess/chessMenu/sideMenu";
import OfferDraw from "./../chess/chessMenu/offerDraw";

import ChessRole from "./../chess/chessRole/chessRole";

import EY_S from "../../../images/EY_S.png";
import RK_B from "../../../images/RK_B.png";
import RK_W from "../../../images/RK_W.png";
import KT_B from "../../../images/KT_B.png";
import KT_W from "../../../images/KT_W.png";
import BP_B from "../../../images/BP_B.png";
import BP_W from "../../../images/BP_W.png";
import QN_B from "../../../images/QN_B.png";
import QN_W from "../../../images/QN_W.png";
import KG_B from "../../../images/KG_B.png";
import KG_W from "../../../images/KG_W.png";
import PN_B from "../../../images/PN_B.png";
import PN_W from "../../../images/PN_W.png";

import "./chess.css";

let socket;
const Chess = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const userState = useSelector(state => state.user);
	const roomState = useSelector(state => state.room);
	const chessState = useSelector(state => state.chess);

	// const roomId = "room101" || roomState._id;
	// const roomName = "Room101" || roomState.roomName;
	// const username = "Player101" || userState.username;
	// const role = "white" || userState.role; // black, white, viewer

	const roomId = roomState._id;
	const roomName = roomState.roomName;
	const username = userState.username;
	const role = userState.role; // black, white, viewer

	const ENDPOINT = window.location.origin;

	let isWhiteTurn = chessState.isWhiteTurn; // Piece turn
	let blackPiece = chessState.blackPiece; // Default blackPiece = ["RK_B", "KT_B", "BP_B", "QN_B", "KG_B", "BP_B", "KT_B", "RK_B", "PN_B", "PN_B", "PN_B", "PN_B", "PN_B", "PN_B", "PN_B", "PN_B"];
	let whitePiece = chessState.whitePiece; // Default whitePiece = ["RK_W", "KT_W", "BP_W", "QN_W", "KG_W", "BP_W", "KT_W", "RK_W", "PN_W", "PN_W", "PN_W", "PN_W", "PN_W", "PN_W", "PN_W", "PN_W"];
	let blackPosition = chessState.blackPosition; // Default blackPosition = [18, 28, 38, 48, 58, 68, 78, 88, 17, 27, 37, 47, 57, 67, 77, 87];
	let whitePosition = chessState.whitePosition; // Default whitePosition = [11, 21, 31, 41, 51, 61, 71, 81, 12, 22, 32, 42, 52, 62, 72, 82];
	let canWhiteCastle = chessState.canWhiteCastle; // Default canWhiteCastle = [true. true]
	let canBlackCastle = chessState.canBlackCastle; // Default canBlackCastle = [true. true]
	let chessHistory = chessState.history; // Default canBlackCastle = [true. true]
	let PieceIndexClicked = 0; // Pieces index representation | Rook: [0, 7] | Kinght: [1, 6] | Bishop: [2, 5] | King: [3] | Queen: [4] | Pawn/Promoted: [8, 9, 10, 11, 12, 13, 14, 15]
	let gameOver = chessState.gameOver; // PV: "true", "false"

	// index representation of promoted Pawn
	const [whitePromotionIndex, setWhitePromotionIndex] = useState(0); // PV: 8, 9, 10, 11, 12, 13, 14, 15
	const [blackPromotionIndex, setBlackPromotionIndex] = useState(0); // PV: 8, 9, 10, 11, 12, 13, 14, 15

	// Hide and show the promotion prompt
	const [whitePromotionVisible, setWhitePromotionVisible] = useState(false); // PV: true, false
	const [blackPromotionVisible, setBlackPromotionVisible] = useState(false); // PV: true, false
	const [chessRoleVisible, setChessRoleVisible] = useState(true); // PV: true, false
	const [offerDrawVisible, setOfferDrawVisible] = useState(false); // PV: true, false

	// action commited before promotion
	const [whitePromotionAction, setWhitePromotionAction] = useState(""); // PV: "move", "capture"
	const [blackPromotionAction, setBlackPromotionAction] = useState(""); // PV: "move", "capture"

	// Captured square position
	let WhiteCaptured = ["01", "02", "03", "04", "05", "06", "07", "08", "91", "92", "93", "94", "95", "96", "97", "98"];
	let blackCaptured = ["10", "20", "30", "40", "50", "60", "70", "80", "19", "29", "39", "49", "59", "69", "79", "89"];

	// Piece username
	const [pieceUsername, setPieceUsername] = useState({ white: "", black: "" }); // PV: "move", "capture"

	useEffect(() => {
		// Checking if a room is setup and if not push to origin
		if (roomId) {
			// renderCaptureHolder(); // Initial render of capture holder
			// renderBoardAndPieces(whitePosition, blackPosition, whitePiece, blackPiece); // Inital render of the board with the default piece position

			socket = io.connect(ENDPOINT); // Joins a board
			socket.emit("join-chess", { username, roomName, role }); // DEBUG // console.log("joined");

			// received the current position and pieces
			socket.on("current-board", ({ board }) => {
				dispatch(InitialPosition(board)); // DEBUG // console.log("current-board", newWhitePosition, newBlackPosition, newWhitePromotion, newBlackPromotion, turn);
				renderCaptureHolder(); // Initial render of capture holder
				renderBoardAndPieces(board.whitePosition, board.blackPosition, board.whitePiece, board.blackPiece);
			});

			// White player moved its piece // this only works for black player || spectator
			socket.on("white-piece-moved", ({ newWhitePosition }) => {
				dispatch(WhiteMoved(newWhitePosition)); // DEBUG // console.log("white-piece-moved", newWhitePosition);
			});

			// black player moved its piece // this only works for white player || spectator
			socket.on("black-piece-moved", ({ newBlackPosition }) => {
				dispatch(BlackMoved(newBlackPosition)); // DEBUG // console.log("black-piece-moved", newBlackPosition);
			});

			// White player captured black piece // this only works for black player || spectator
			socket.on("white-captured-black", ({ newWhitePosition, newBlackPosition }) => {
				dispatch(WhiteCapturedBlack(newWhitePosition, newBlackPosition)); // DEBUG // console.log("white-captured-black", newWhitePosition, newBlackPosition);
			});

			// black player captured black piece // this only works for white player || spectator
			socket.on("black-captured-white", ({ newWhitePosition, newBlackPosition }) => {
				dispatch(BlackCapturedWhite(newWhitePosition, newBlackPosition)); // DEBUG // console.log("black-captured-white", newWhitePosition, newBlackPosition);
			});

			// // white player promoted its piece by moving // this only works for black player || spectator
			socket.on("white-promoted-by-move", ({ newWhitePiece, newWhitePosition }) => {
				dispatch(WhitePromotedByMove(newWhitePiece, newWhitePosition)); // DEBUG // console.log("white-piece-promoted", newWhitePiece);
			});

			// // black player promoted its piece by capturing // this only works for white player || spectator
			socket.on("black-promoted-by-move", ({ newBlackPiece, newBlackPosition }) => {
				dispatch(BlackPromotedByMove(newBlackPiece, newBlackPosition));
			});

			// // white player promoted its piece by capturing // this only works for black player || spectator
			socket.on("white-promoted-by-capture", ({ newWhitePiece, newWhitePosition, newBlackPosition }) => {
				dispatch(WhitePromotedByCapture(newWhitePiece, newWhitePosition, newBlackPosition)); // DEBUG // console.log("white-piece-promoted", newWhitePiece);
			});

			// // black player promoted its piece by capturing // this only works for white player || spectator
			socket.on("black-promoted-by-capture", ({ newBlackPiece, newWhitePosition, newBlackPosition }) => {
				dispatch(BlackPromotedByCapture(newBlackPiece, newWhitePosition, newBlackPosition)); // DEBUG // console.log("white-piece-promoted", newWhitePiece);
			});

			// White player castled its piece // this only works for black player || spectator
			socket.on("white-castled", ({ newWhitePosition }) => {
				dispatch(WhiteCastled(newWhitePosition)); // DEBUG // console.log("white-castled", newWhitePosition);
			});

			// black player castled its piece // this only works for white player || spectator
			socket.on("black-castled", ({ newBlackPosition }) => {
				dispatch(BlackCastled(newBlackPosition)); // DEBUG // console.log("black-castled", newBlackPosition);
			});

			// White player moved king/rook piece // this only works for black player || spectator
			socket.on("white-castle-updated", ({ whiteCastleState }) => {
				dispatch(SetWhiteCastleState(whiteCastleState)); // DEBUG // console.log("white-castle-updated", whiteCastleState);
			});

			// Black player moved king/rook piece // this only works for White player || spectator
			socket.on("black-castle-updated", ({ blackCastleState }) => {
				dispatch(SetBlackCastleState(blackCastleState)); // DEBUG // console.log("black-castle-updated", blackCastleState);
			});

			socket.on("add-history", ({ history }) => {
				dispatch(AddHistory(history)); // DEBUG // console.log("add-history", history);
			});

			socket.on("selected-role-valid", ({ selectedRole }) => {
				dispatch(SetRole(selectedRole));
				setChessRoleVisible(false);
			});

			socket.on("selected-role-invalid", ({ selectedRole }) => {
				dispatch(SetRole(`${selectedRole} ALREADY TAKEN`.toUpperCase()));
			});

			socket.on("update-players", ({ white, black }) => {
				setPieceUsername({ white, black });
			});

			socket.on("game-finished", ({ gameOver }) => {
				if (!chessState.gameOver) dispatch(SetGameOver(gameOver));
			});

			socket.on("offered-draw", () => {
				setOfferDrawVisible(true);
			});
		} else history.push("/");
		return () => {
			if (roomId) {
				dispatch(SetRole("")); // Clears the role
				dispatch(roomLeave()); // clears the room state
				socket.disconnect(); // disconnects the socket
			}
		};
	}, [ENDPOINT]);

	// player move/capture
	useEffect(() => {
		// it needs to get a role first before getting the
		if (role) {
			renderBoardAndPieces(whitePosition, blackPosition, whitePiece, blackPiece); // Re-render the board everytime a move/capture/promotion is made
			checkGameOver(); // Checking for check and if the player still has valid move
		}
	}, [chessState.isWhiteTurn]);

	useEffect(() => {
		if (role) {
			renderCaptureHolder(); // Initial render of capture holder
			renderBoardAndPieces(whitePosition, blackPosition, whitePiece, blackPiece);
		}
	}, [userState.role]);

	// class the function whenever the board is clicked
	function BoardClicked() {
		const ID = window.event.target.id; // Id of the clicked square (e.i. P11) // DEBUG // console.log(`\n\nClicked ID: ${ID}`);
		const selectedSquareBackgroundColor = getComputedStyle(window.event.target, null).getPropertyValue("background-color"); // background color of the selected square (e.i. "rgb(0,255,0)")
		if (ID) {
			let clickedPosition = parseInt(ID.substring(1, 3)); // remove the "P" from ID to get the position (P11 -> 11)
			if (IsPieceClicked(clickedPosition)) MoveScope();
			else if (selectedSquareBackgroundColor === "rgb(0, 255, 0)") pieceMove(clickedPosition, ID[2]);
			else if (selectedSquareBackgroundColor === "rgb(255, 0, 0)") pieceCapture(clickedPosition, ID[2]);
			else if (selectedSquareBackgroundColor === "rgb(125, 125, 255)") pieceCastling(clickedPosition);
			else if (selectedSquareBackgroundColor === "rgb(255, 100, 100)") piecePassPawn(clickedPosition);
			else renderBoardAndPieces(whitePosition, blackPosition, whitePiece, blackPiece); // Re-render the board with no highlighted move
		}
	}

	// Checks if the clicked square is a white/black piece or just an open board
	function IsPieceClicked(id) {
		// :  white turns and white piece clicked  :  black turns and black piece clicked  :  board || black turns and white piece clicked || white turns and black piece clicked
		if (isWhiteTurn && whitePosition.includes(id)) PieceIndexClicked = whitePosition.indexOf(id);
		else if (!isWhiteTurn && blackPosition.includes(id)) PieceIndexClicked = blackPosition.indexOf(id);
		else return false;
		return true;
	}

	// creates an highlight on what square you can move/capture/castling
	// green: open,
	// red: opponent's piece
	// Blue: castling
	// none: out of range / own piece
	function MoveScope() {
		renderBoardAndPieces(whitePosition, blackPosition, whitePiece, blackPiece); // Re-render the board with no highlighted move

		let PositionArray = isWhiteTurn ? whitePosition : blackPosition; // setting the right position array according to player's turn
		const positionX = parseInt(PositionArray[PieceIndexClicked].toString()[0]); // clicked piece X-position
		const positionY = parseInt(PositionArray[PieceIndexClicked].toString()[1]); // clicked piece Y-position
		const piece = document.getElementById(`P${PositionArray[PieceIndexClicked]}`).src; // getting image of the clicked piece

		// Determining the piece is clicked and setting the move scope
		if (piece === PN_B || piece === PN_W)
			PawnScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition, chessHistory[chessHistory.length - 1]);
		else if (piece === RK_B || piece === RK_W) RookScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition);
		else if (piece === KT_B || piece === KT_W) KnightScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition);
		else if (piece === BP_B || piece === BP_W) BishopScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition);
		else if (piece === KG_B || piece === KG_W)
			KingScopeMove(
				positionX,
				positionY,
				isWhiteTurn,
				blackPosition,
				whitePosition,
				canWhiteCastle,
				canBlackCastle,
				whitePiece,
				blackPiece
			);
		else if (piece === QN_B || piece === QN_W) {
			BishopScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition);
			RookScopeMove(positionX, positionY, isWhiteTurn, blackPosition, whitePosition);
		}
	}

	function pieceMove(clickedPosition, positionY) {
		// Piece moved to the board // DEBUG // console.log(`- Piece Moved (P${isWhiteTurn ? whitePosition[PieceIndexClicked] : blackPosition[PieceIndexClicked]} -> ${ID}) -`);  console.log(`Color: ${isWhiteTurn ? "White" : "black"}`); console.log(`INDEX: ${PieceIndexClicked}`); console.log(`clickedPosition: ${ID[2]}`);
		// Determining what color piece moved
		if (isWhiteTurn) {
			whitePosition[PieceIndexClicked] = clickedPosition; // White Piece moved to the board
			if (whitePiece[PieceIndexClicked] === "PN_W" && positionY == "8") {
				// White pawn move with a promotion // White pawn reaches the top square
				setWhitePromotionVisible(true); // make the white promotion prompt visible
				setWhitePromotionIndex(PieceIndexClicked); // index of promoted piece
				setWhitePromotionAction("move"); // action taken before promotion
			} else {
				// White piece casual move
				socket.emit("white-piece-moves", { roomName, newWhitePosition: whitePosition }); // Emit to server that white moved and its updated whitePosition
				dispatch(WhiteMoved(whitePosition)); // DEBUG // console.log("white-piece-moved", newWhitePosition);
			}
		} else {
			blackPosition[PieceIndexClicked] = clickedPosition; // Black Piece moved to the board
			if (blackPiece[PieceIndexClicked] === "PN_B" && positionY == "1") {
				// Black pawn move with a promotion // Black pawn reaches the top square
				setBlackPromotionVisible(true); // make the black promotion prompt visible
				setBlackPromotionIndex(PieceIndexClicked); // index of promoted piece
				setBlackPromotionAction("move"); // action taken before promotion
			} else {
				// Black piece casual move
				socket.emit("black-piece-moves", { roomName, newBlackPosition: blackPosition }); // Emit to server that white moved and its updated whitePosition
				dispatch(BlackMoved(blackPosition)); // DEBUG // console.log("black-piece-moved", newBlackPosition);
			}
		} // DEBUG // isWhiteTurn ? console.log("blackPosition:", blackPosition) : console.log("whitePosition:", whitePosition);

		castlingStateUpdate(PieceIndexClicked); // disable castling state if the piece moved is rook || king
	}

	function pieceCapture(clickedPosition, positionY) {
		// Piece capture
		let capturerPosArray = isWhiteTurn ? whitePosition : blackPosition;
		let capturedPosArray = isWhiteTurn ? blackPosition : whitePosition;
		const capturedHolder = isWhiteTurn ? blackCaptured : WhiteCaptured; // DEBUG // console.log(`- Piece Captures (P${capturerPosArray[PieceIndexClicked]} -> ${ID}) -`); console.log(`Color: ${isWhiteTurn ? "White" : "black"}`); console.log(`INDEX: ${PieceIndexClicked}`);

		capturerPosArray[PieceIndexClicked] = clickedPosition; // Reposition capturer piece on the clicked position
		// Reposition captured piece on capture holder
		const index = capturedPosArray.indexOf(clickedPosition);
		for (let a = 0; a < capturedHolder.length; a++) {
			// If the blackPosition already have the a captured piece move to next until the unoccupied capture positon came
			if (capturedPosArray.indexOf(capturedHolder[a]) === -1) {
				capturedPosArray[index] = capturedHolder[a];
				break;
			}
		} // DEBUG // console.log("whitePosition:", whitePosition); console.log("blackPosition:", blackPosition);
		if (isWhiteTurn && positionY == "8" && whitePiece[PieceIndexClicked] === "PN_W") {
			// White pawn capture with promotion // index for pawn (8-15) && Y position 8 is top square && whitePromotion is not been promoted
			setWhitePromotionVisible(true); // make the white promotion prompt visible
			setWhitePromotionIndex(PieceIndexClicked); // index of promoted piece
			setWhitePromotionAction("capture"); // action taken before promotion
		} else if (isWhiteTurn) {
			// White Pawn Casual Capture
			socket.emit("white-piece-captures", {
				roomName,
				newWhitePosition: capturerPosArray,
				newBlackPosition: capturedPosArray,
			}); // Emit to server that white captures black piece and its updated whitePosition and blackPosition
			dispatch(WhiteCapturedBlack(capturerPosArray, capturedPosArray)); // DEBUG // console.log("white-captured-black", newWhitePosition, newBlackPosition);
		} else if (!isWhiteTurn && positionY == "1" && blackPiece[PieceIndexClicked] === "PN_B") {
			// Black pawn capture with promotion // index for pawn (8-15) && Y position 1 is top square && blackPromotion is not been promoted
			setBlackPromotionVisible(true); // make the white promotion prompt visible
			setBlackPromotionIndex(PieceIndexClicked); // index of promoted piece
			setBlackPromotionAction("capture"); // action taken before promotion
		} else if (!isWhiteTurn) {
			// Black Pawn Casual Capture
			socket.emit("black-piece-captures", {
				roomName,
				newWhitePosition: capturedPosArray,
				newBlackPosition: capturerPosArray,
			}); // Emit to server that black captures white piece and its updated whitePosition and blackPosition
			dispatch(BlackCapturedWhite(capturedPosArray, capturerPosArray)); // DEBUG // console.log("black-captured-white", newWhitePosition, newBlackPosition);
		}

		castlingStateUpdate(capturedPosArray.indexOf(clickedPosition)); // disable castling state if the piece captured is rook
		castlingStateUpdate(PieceIndexClicked); // disable castling state if the piece moved is rook || king
	}

	function pieceCastling(clickedPosition) {
		// Piece castling
		if (clickedPosition == 71) {
			whitePosition[4] = 71; // Position white king in castle (right)
			whitePosition[7] = 61; // Position white rook in castle (right) // DEBUG // console.log("whitePosition", whitePosition);
			socket.emit("white-castles", { roomName, newWhitePosition: whitePosition }); // Emit to server that white moved and its updated whitePosition
			dispatch(WhiteCastled(whitePosition)); // DEBUG // console.log("white-castled", newWhitePosition);
		}
		if (clickedPosition == 31) {
			whitePosition[4] = 31; // Position white king in castle (left)
			whitePosition[0] = 41; // Position white rook in castle (left) // DEBUG // console.log("whitePosition", whitePosition);
			socket.emit("white-castles", { roomName, newWhitePosition: whitePosition }); // Emit to server that white moved and its updated whitePosition
			dispatch(WhiteCastled(whitePosition)); // DEBUG // console.log("white-castled", newWhitePosition);
		}

		if (clickedPosition == 78) {
			blackPosition[4] = 78; // Position white king in castle (right)
			blackPosition[7] = 68; // Position white rook in castle (right) // DEBUG // console.log("blackPosition", blackPosition);
			socket.emit("black-castles", { roomName, newBlackPosition: blackPosition }); // Emit to server that white moved and its updated whitePosition
			dispatch(BlackCastled(blackPosition)); // DEBUG // console.log("black-castled", newBlackPosition);
		}
		if (clickedPosition == 38) {
			blackPosition[4] = 38; // Position white king in castle (left)
			blackPosition[0] = 48; // Position white rook in castle (left) // DEBUG // console.log("blackPosition", blackPosition);
			socket.emit("black-castles", { roomName, newBlackPosition: blackPosition }); // Emit to server that white moved and its updated whitePosition
			dispatch(BlackCastled(blackPosition)); // DEBUG // console.log("black-castled", newBlackPosition);
		}
		castlingStateUpdate(4);
	}
	function castlingStateUpdate(index) {
		// disable castling state if the piece moved is rook || king then
		switch (index) {
			case 0:
				// Left rook moved -> Disable left castling
				if (isWhiteTurn && canWhiteCastle[0]) {
					canWhiteCastle[0] = false; // disable left castle
					socket.emit("white-castle-updates", { roomName, whiteCastleState: canWhiteCastle });
					dispatch(SetWhiteCastleState(canWhiteCastle)); // DEBUG // console.log("white-castle-updates", canWhiteCastle);
				} else if (!isWhiteTurn && canBlackCastle[0]) {
					canBlackCastle[0] = false; // disable left and right castle
					socket.emit("black-castle-updates", { roomName, blackCastleState: canBlackCastle });
					dispatch(SetBlackCastleState(canBlackCastle)); // DEBUG // console.log("black-castle-updates", blackCastleState);
				}
				break;
			case 7:
				// Right rook moved -> Disable right castling
				if (isWhiteTurn && canWhiteCastle[1]) {
					canWhiteCastle[1] = false; // disable right castle
					socket.emit("white-castle-updates", { roomName, whiteCastleState: canWhiteCastle });
					dispatch(SetWhiteCastleState(canWhiteCastle)); // DEBUG // console.log("white-castle-updates", canWhiteCastle);
				} else if (!isWhiteTurn && canBlackCastle[1]) {
					canBlackCastle[1] = false; // disable left and right castle
					socket.emit("black-castle-updates", { roomName, blackCastleState: canBlackCastle });
					dispatch(SetBlackCastleState(canBlackCastle)); // DEBUG // console.log("black-castle-updates", blackCastleState);
				}
				break;
			case 4:
				// King moved -> Disable right and left castling
				if (isWhiteTurn && (canWhiteCastle[0] || canWhiteCastle[1])) {
					canWhiteCastle = [false, false]; // disable left and right castle
					socket.emit("white-castle-updates", { roomName, whiteCastleState: canWhiteCastle });
					dispatch(SetWhiteCastleState(canWhiteCastle)); // DEBUG // console.log("white-castle-updates", canWhiteCastle);
				} else if (!isWhiteTurn && (canBlackCastle[0] || canBlackCastle[1])) {
					canBlackCastle = [false, false]; // disable left and right castle
					socket.emit("black-castle-updates", { roomName, blackCastleState: canBlackCastle });
					dispatch(SetBlackCastleState(canBlackCastle)); // DEBUG // console.log("black-castle-updates", blackCastleState);
				}
				break;
		}
	}

	function piecePassPawn(clickedPosition) {
		// Piece capture
		let capturerPosArray = isWhiteTurn ? whitePosition : blackPosition;
		let capturedPosArray = isWhiteTurn ? blackPosition : whitePosition;
		const capturedHolder = isWhiteTurn ? blackCaptured : WhiteCaptured; // DEBUG // console.log(`- Piece Captures (P${capturerPosArray[PieceIndexClicked]} -> ${ID}) -`); console.log(`Color: ${isWhiteTurn ? "White" : "black"}`); console.log(`INDEX: ${PieceIndexClicked}`);
		capturerPosArray[PieceIndexClicked] = clickedPosition; // Reposition capturer piece on the clicked position

		// Reposition captured piece on capture holder
		const index = isWhiteTurn ? capturedPosArray.indexOf(clickedPosition - 1) : capturedPosArray.indexOf(clickedPosition + 1);
		for (let a = 0; a < capturedHolder.length; a++) {
			// If the blackPosition already have the a captured piece move to next until the unoccupied capture positon came
			if (capturedPosArray.indexOf(capturedHolder[a]) === -1) {
				capturedPosArray[index] = capturedHolder[a];
				break;
			}
		} // DEBUG // console.log("whitePosition:", whitePosition); console.log("blackPosition:", blackPosition);

		if (isWhiteTurn) {
			// White Pawn  Capture pass pawn
			socket.emit("white-piece-captures", {
				roomName,
				newWhitePosition: capturerPosArray,
				newBlackPosition: capturedPosArray,
			}); // Emit to server that white captures black piece and its updated whitePosition and blackPosition
			dispatch(WhiteCapturedBlack(capturerPosArray, capturedPosArray)); // DEBUG // console.log("white-captured-black", newWhitePosition, newBlackPosition);
		} else {
			// Black Pawn Capture pass pawn
			socket.emit("black-piece-captures", {
				roomName,
				newWhitePosition: capturedPosArray,
				newBlackPosition: capturerPosArray,
			}); // Emit to server that black captures white piece and its updated whitePosition and blackPosition
			dispatch(BlackCapturedWhite(capturedPosArray, capturerPosArray)); // DEBUG // console.log("black-captured-white", newWhitePosition, newBlackPosition);
		}
	}

	// handle the chosen promotion then continue to move/capture the piece
	function handlePiecePromotion(piece, colorPiece) {
		let newPieceArray = colorPiece == "white" ? [...whitePiece] : [...blackPiece]; // duplicating the right position array according to colorPiece
		const index = colorPiece == "white" ? whitePromotionIndex : blackPromotionIndex; // Getting the index of the promoted pawn according to colorPiece

		// Sets whitePiece Array || blackPiece Array with the updated promotion piece
		switch (piece) {
			case "rook":
				colorPiece == "white" ? (newPieceArray[index] = "RK_W") : (newPieceArray[index] = "RK_B");
				break;
			case "knight":
				colorPiece == "white" ? (newPieceArray[index] = "KT_W") : (newPieceArray[index] = "KT_B");
				break;
			case "bishop":
				colorPiece == "white" ? (newPieceArray[index] = "BP_W") : (newPieceArray[index] = "BP_B");
				break;
			case "queen":
				colorPiece == "white" ? (newPieceArray[index] = "QN_W") : (newPieceArray[index] = "QN_B");
				break;
		}

		if (colorPiece == "white" && whitePromotionAction === "move") {
			// action made by the pawn for promotion is to move
			socket.emit("white-promotion-by-move", { roomName, newWhitePiece: newPieceArray, newWhitePosition: whitePosition });
			dispatch(WhitePromotedByMove(newPieceArray, whitePosition)); // DEBUG // console.log("white-piece-promoted", newWhitePiece);
			setWhitePromotionVisible(false); // make the white promotion prompt hidden
		} else if (colorPiece == "black" && blackPromotionAction === "move") {
			// action made by the pawn for promotion is to move
			socket.emit("black-promotion-by-move", { roomName, newBlackPiece: newPieceArray, newBlackPosition: blackPosition });
			dispatch(BlackPromotedByMove(newPieceArray, blackPosition));
			setBlackPromotionVisible(false); // make the black promotion prompt hidden
		} else if (colorPiece == "white" && whitePromotionAction === "capture") {
			// action made by the pawn for promotion is to capture
			socket.emit("white-promotion-by-capture", {
				roomName,
				newWhitePiece: newPieceArray,
				newWhitePosition: whitePosition,
				newBlackPosition: blackPosition,
			});
			dispatch(WhitePromotedByCapture(newPieceArray, whitePosition, blackPosition)); // DEBUG // console.log("white-piece-promoted", newWhitePiece);
			setWhitePromotionVisible(false); // make the white promotion prompt hidden
		} else if (colorPiece == "black" && blackPromotionAction === "capture") {
			// action made by the pawn for promotion is to capture
			socket.emit("black-promotion-by-capture", {
				roomName,
				newBlackPiece: newPieceArray,
				newWhitePosition: whitePosition,
				newBlackPosition: blackPosition,
			});
			dispatch(BlackPromotedByCapture(newPieceArray, whitePosition, blackPosition)); // DEBUG // console.log("white-piece-promoted", newWhitePiece);
			setBlackPromotionVisible(false); // make the black promotion prompt hidden
		}
	}

	function checkGameOver() {
		// Open Check
		const target = !isWhiteTurn ? whitePosition[4] : blackPosition[4];
		const isOpponentKingCheck = isUnderAttack(!isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, target);
		if (isOpponentKingCheck) {
			console.log("aaaaaaaaaaaaahhh Failed to defend king");

			gameOver = isWhiteTurn ? "BLACK FAILED TO DEFEND ITS KING" : "WHITE FAILED TO DEFEND ITS KING";
			// dispatch(SetGameOver(gameOver));

			// The piece that moved the last will be the one recording the game to avoid double records
			if (!isWhiteTurn && role === "white") {
				if (pieceUsername.white) UpdateRank(pieceUsername.white, "lose");
				if (pieceUsername.black) UpdateRank(pieceUsername.black, "win");
			} else if (isWhiteTurn && role === "black") {
				if (pieceUsername.white) UpdateRank(pieceUsername.white, "win");
				if (pieceUsername.black) UpdateRank(pieceUsername.black, "lose");
			}
			socket.emit("game-over", { roomName, gameOver });
		}

		const isPlayerOutOfMove = isOutOfMove(
			isWhiteTurn,
			whitePosition,
			blackPosition,
			whitePiece,
			blackPiece,
			canWhiteCastle,
			canBlackCastle,
			chessHistory[chessHistory.length - 1]
		);
		const Owntarget = isWhiteTurn ? whitePosition[4] : blackPosition[4];
		const isOwnKingCheck = isUnderAttack(isWhiteTurn, whitePosition, blackPosition, whitePiece, blackPiece, Owntarget);
		// CHECK MATE
		if (isPlayerOutOfMove && isOwnKingCheck) {
			console.log("aaaaaaaaaaaaahhh checkmate");
			console.log("Checkmate", isPlayerOutOfMove && isOwnKingCheck, isOpponentKingCheck);
			// dispatch(SetGameOver("CHECK MATE"));

			// The piece that moved the last will be the one recording the game to avoid double records
			if (!isWhiteTurn && role === "white") {
				if (pieceUsername.white) UpdateRank(pieceUsername.white, "win");
				if (pieceUsername.black) UpdateRank(pieceUsername.black, "lose");
			} else if (isWhiteTurn && role === "black") {
				if (pieceUsername.white) UpdateRank(pieceUsername.white, "lose");
				if (pieceUsername.black) UpdateRank(pieceUsername.black, "win");
			}
			socket.emit("game-over", { roomName, gameOver: `${isWhiteTurn ? "WHITE" : "BLACK"} CHECK MATED` });
		}
		// STEAL MATE
		else if (isPlayerOutOfMove && !isOpponentKingCheck) {
			console.log("aaaaaaaaaaaaahhh stealMate");
			console.log("steal mate");
			// dispatch(SetGameOver("OUT OF MOVE"));

			// The piece that moved the last will be the one recording the game to avoid double records
			if ((!isWhiteTurn && role === "white") || (isWhiteTurn && role === "black")) {
				if (pieceUsername.white) UpdateRank(pieceUsername.white, "draw");
				if (pieceUsername.black) UpdateRank(pieceUsername.black, "draw");
			}
			socket.emit("game-over", { roomName, gameOver: "STALEMATE" });
		}
	}

	// update database's rank list
	function UpdateRank(username, game) {
		axios
			.put("/api/rank/user/update", { username, game })
			.then(() => console.log("successfully updated Rank list"))
			.catch(e => console.log("add Track failed:", e));
	}

	// --- Function props ---
	// GameoverMenu: onClick reset button
	function handleResetBoard() {
		socket.emit("reset-board", { roomName });
	}

	// ChessRole: onClick preffered role
	function handleSelectionRole(playerRole) {
		socket.emit("select-role", { username, roomName, role: playerRole });
	}

	// SideMenu: onClick Resign
	function handleResignation() {
		console.log("Resign");
		// dispatch(SetGameOver(`${role.toUpperCase()} RESIGN FROM THE GAME`));
		if (role === "white") {
			if (pieceUsername.white) UpdateRank(pieceUsername.white, "lose");
			if (pieceUsername.black) UpdateRank(pieceUsername.black, "win");
		} else {
			if (pieceUsername.white) UpdateRank(pieceUsername.white, "win");
			if (pieceUsername.black) UpdateRank(pieceUsername.black, "lose");
		}
		socket.emit("game-over", { roomName, gameOver: `${role.toUpperCase()} RESIGN FROM THE GAME` });
	}

	// SideMenu: onClick Resign
	function handleDraw() {
		socket.emit("offer-draw", { roomName });
	}

	function handleDrawOffer(isAccepted) {
		setOfferDrawVisible(false);
		if (isAccepted) {
			if (pieceUsername.white) UpdateRank(pieceUsername.white, "draw");
			if (pieceUsername.black) UpdateRank(pieceUsername.black, "draw");
			socket.emit("game-over", { roomName, gameOver: `PLAYERS AGREED TO DRAW` });
		}
	}

	// --- Function props ---

	return (
		<div className="chess-page">
			<div className={(role === "black" && !isWhiteTurn) || (role === "white" && isWhiteTurn) ? "board-enable" : "board-disable"}>
				{role == "black" ? <BoardBlack BoardClicked={BoardClicked} /> : <BoardWhite BoardClicked={BoardClicked} />}
			</div>

			<SideMenu handleResignation={handleResignation} handleDraw={handleDraw} />

			<OfferDraw offerDrawVisible={offerDrawVisible} handleDrawOffer={handleDrawOffer} />

			<PromotionWhite whitePromotionVisible={whitePromotionVisible} handlePiecePromotion={handlePiecePromotion} />
			<PromotionBlack blackPromotionVisible={blackPromotionVisible} handlePiecePromotion={handlePiecePromotion} />

			<GameOverMenu gameOver={gameOver} isWhiteTurn={isWhiteTurn} handleResetBoard={handleResetBoard} />

			<ChessRole handleRole={handleSelectionRole} chessRoleVisible={chessRoleVisible} />
		</div>
	);
};

export default Chess;
